/* eslint-disable @typescript-eslint/no-unused-vars */

import { updateComponent } from '../../../../app/package-designer/store/component.actions';

xplenty.directive('windowEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./window-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        'ngrxStoreService',
        function ($scope, ngrxStoreService) {
          function callValidityChange() {
            // if group by is selected for grouping_type, group by collection must be valid, otherwise be valid. same for data_order
            const valid =
              !($scope.component.grouping_type === 'group_by' && !$scope.groupByCollectionValidity) &&
              !($scope.component.data_order === 'sort' && !$scope.sortCollectionValidity) &&
              $scope.windowCollectionValidity;

            $scope.onValidityChange(valid);
          }

          $scope.onGroupingTypeChange = ({ grouping_type }) => {
            const component = { grouping_type };
            if (grouping_type === 'all') {
              component.partitioned_fields = [];
            }
            ngrxStoreService.dispatch(updateComponent({ component }));
            callValidityChange();
          };

          $scope.onDataOrderChange = ({ data_order }) => {
            $scope.component.data_order = data_order;
            const component = { data_order };
            if (data_order === 'no_sort') {
              component.ordered_fields = [];
            }
            ngrxStoreService.dispatch(updateComponent({ component }));
            callValidityChange();
          };

          $scope.onSortCollectionValidityChange = (value) => {
            $scope.sortCollectionValidity = value;
            callValidityChange();
          };

          $scope.onOrderedFieldsChange = (value) => {
            $scope.component.ordered_fields = value;
            callValidityChange();
          };

          $scope.onPartitionedFieldsChange = (value) => {
            $scope.component.partitioned_fields = value;
            callValidityChange();
          };

          $scope.onPartitionedFieldsValidityChange = (value) => {
            $scope.groupByCollectionValidity = value;
            callValidityChange();
          };

          $scope.onWindowedFieldsChange = (value) => {
            $scope.component.windowed_fields = value;
            callValidityChange();
          };

          $scope.onWindowedFieldsValidityChange = (value) => {
            $scope.windowCollectionValidity = value;
            callValidityChange();
          };
        },
      ],
    };
  },
]);
